
import Vue from "vue";
import { ViewSidebarBlock } from "@/utils/views/view-sidebar";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import { getSidebarBlockDefinition, getSidebarBlockName, ISidebarBlockDefinition } from "@/utils/views/sidebar-blocks";
import { getModel, Model } from "@/utils/models/model";
import AppSidebarFieldsBlock from "./SidebarFieldsBlock.vue";

export default Vue.extend({
	data(){
		return {
			collapsed: this.block.Collapsed,
			itemVersion: 0,
			summary: ""
		};
	},
	props: {
		block: {
			type: Object as () => ViewSidebarBlock,
			required: true
		},
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		definition():ISidebarBlockDefinition | undefined {
			if (this.block.isFieldsBlock) return undefined;
			return getSidebarBlockDefinition(this.block.Type);
		},
		component():any {
			if (!this.definition) return null;
			return this.definition.component;
		},
		title():string {
			if (this.block.Title) return this.block.Title;
			if (this.block.isFieldsBlock) return this.$ct("sidebar.fields-block").toString();
			return getSidebarBlockName(this.block.Type);
		},
		model():Model {
			return getModel(this.state.dataSource.modelName);
		}
	},
	watch: {
		item(newItem:any, oldItem:any){
			this.itemVersion++;
			if (!newItem || !oldItem || newItem.ID != oldItem.ID) {
				this.summary = "";
			}
		}
	},
	components: {
		AppSidebarFieldsBlock
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
